module.exports = __webpack_public_path__ + "img/pic2.6bceab0d.png";